import {createApi, fetchBaseQuery} from "@reduxjs/toolkit/query/react";
import axios from "../utils/axios";
import environments from "../utils/environments";
import {CoreService} from "../services/core.service";
import {ApiListInterface} from "../interfaces/entity";

export interface APILinksItemData {
    "id": number;
    "user_id": number;
    "url": string;
    "status_id": number;
    "is_upload_to_bb": number;
    "created_at": string;
    "status_name": string;
    "files": any[]
}


export const api = createApi({
    reducerPath: "api",
    baseQuery: fetchBaseQuery({baseUrl: "http://localhost:7070/api/"}),
    endpoints: (builder) => ({
        getLinks: builder.query<ApiListInterface<APILinksItemData>, void>({
            queryFn: async () => {
                try {
                    const response = await (new CoreService()).getLinks()
                    console.log(response)
                    return {data: await response.data}
                } catch (e) {
                    return {error: e.message}
                }
            },
            keepUnusedDataFor: 0,
        })
    }),
});

export const {
    useGetLinksQuery,
} = api;
